import { CreditCard, Fire, Package, Tag } from '@phosphor-icons/react'
import { FC } from 'react'
import { WidgetSections } from 'src/lib/contexts/AnalyticsContext/types'

interface SectionType {
  id: string
  label: string
  icon: React.ReactNode
  title?: string
}

interface AnalyticsSidebarProps {
  sections: {
    primary: {
      sections: SectionType[]
      title: string
    }
    secondary: {
      sections: SectionType[]
      title: string
    }
  }
  activeSection: string | undefined
  setActiveSection: (section: WidgetSections) => void
}

const iconMap = {
  fire: Fire,
  package: Package,
  creditCard: CreditCard,
  tag: Tag
}

const SectionIcon = ({
  icon,
  color = 'currentColor',
  isActive = false
}: {
  icon: keyof typeof iconMap
  color?: string
  isActive?: boolean
}) => {
  const Icon = iconMap[icon]
  return <Icon color={isActive ? '#01CCA7' : color} weight={isActive ? 'fill' : 'regular'} size={18} />
}

const AnalyticsTopbar: FC<AnalyticsSidebarProps> = ({ sections, activeSection, setActiveSection }) => {
  return (
    <div className='w-full bg-white rounded-2xl'>
      <nav className='flex items-center px-4 justify-between'>
        {sections.primary.sections.map(section => (
          <button
            id={section.id}
            key={section.id}
            onClick={() => setActiveSection(section.id as WidgetSections)}
            className={`
              flex items-center px-4 py-2 text-sm font-medium space-x-2 relative rounded-xl
              ${
                activeSection === section.id
                  ? 'text-primary border-1 border-primary-dark font-semibold'
                  : 'text-gray-600 hover:text-gray-900 border-1 border-transparent'
              }
            `}
          >
            <span>
              {section.icon && iconMap[section.icon as keyof typeof iconMap] && (
                <SectionIcon
                  icon={section.icon as keyof typeof iconMap}
                  isActive={activeSection === section.id}
                  color={activeSection === section.id ? '#01CCA7' : '#64748B'}
                />
              )}
            </span>
            <span>{section.label}</span>
          </button>
        ))}

        {sections.secondary.sections.length > 0 && (
          <>
            <div className='flex-grow' />
            {sections.secondary.sections.map(section => (
              <button
                id={section.id}
                key={section.id}
                onClick={() => setActiveSection(section.id as WidgetSections)}
                className={`
                  flex items-center px-4 py-2 text-sm font-medium space-x-2 relative rounded-xl
                  ${
                    activeSection === section.id
                      ? 'text-primary border-1 border-primary-dark font-semibold'
                      : 'text-gray-600 hover:text-gray-900 border-1 border-transparent'
                  }
                `}
              >
                <span>
                  {section.icon && iconMap[section.icon as keyof typeof iconMap] && (
                    <SectionIcon
                      icon={section.icon as keyof typeof iconMap}
                      isActive={activeSection === section.id}
                      color={activeSection === section.id ? '#01CCA7' : '#64748B'}
                    />
                  )}
                </span>
                <span>{section.label}</span>
              </button>
            ))}
          </>
        )}
      </nav>
    </div>
  )
}

export default AnalyticsTopbar
